import { render, staticRenderFns } from "./ReorderClient.vue?vue&type=template&id=b7897d94&scoped=true&"
import script from "./ReorderClient.vue?vue&type=script&lang=js&"
export * from "./ReorderClient.vue?vue&type=script&lang=js&"
import style0 from "./ReorderClient.vue?vue&type=style&index=0&id=b7897d94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7897d94",
  null
  
)

export default component.exports